export default __webpack_public_path__ + "static/media/play-button.2b72c4f1.svg";